import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import './../App.css';

class DesktopHeader extends Component {
  render() {
    return (
        <nav id="DesktopHeader">
            <Link to="/">Home</Link>
            <Link to="/empresa">Empresa</Link>
            <Link to="/localizacao">Localização</Link>
            <Link to="produtos">Produtos</Link>
            <Link to="ilpf">O que é ilpf</Link>
            <Link to="contato">Contato</Link>
        </nav>
    );
  }
}

export default DesktopHeader;



// WEBPACK FOOTER //
// ./src/Header/DesktopHeader.js